var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.447 6.105L15.447 3.105C15.3081 3.03548 15.1549 2.99928 14.9995 2.99928C14.8441 2.99928 14.6909 3.03548 14.552 3.105L9 5.882L3.447 3.105C3.2945 3.0288 3.12506 2.99284 2.95476 3.00056C2.78446 3.00827 2.61895 3.05939 2.47397 3.14907C2.32899 3.23874 2.20933 3.36399 2.12638 3.51293C2.04342 3.66186 1.99992 3.82952 2 4L2 17C2 17.379 2.214 17.725 2.553 17.895L8.553 20.895C8.69193 20.9645 8.84515 21.0007 9.0005 21.0007C9.15585 21.0007 9.30907 20.9645 9.448 20.895L15 18.118L20.553 20.894C20.7051 20.9709 20.8744 21.0074 21.0446 20.9998C21.2149 20.9923 21.3803 20.9411 21.525 20.851C21.82 20.668 22 20.347 22 20V7C22 6.621 21.786 6.275 21.447 6.105V6.105ZM10 7.618L14 5.618V16.382L10 18.382V7.618ZM4 5.618L8 7.618V18.382L4 16.382L4 5.618ZM20 18.382L16 16.382V5.618L20 7.618V18.382Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.b049dbfa3facd90adc3af9e189e552b5.svg";
export { ForwardRef as ReactComponent };